import { buildCounsellingWhatsAppUrl } from '@/lib/siteConfig'
import { useCurrentTime } from '@/lib/hydration'
import { buttonClassName } from '@/components/ui/buttonStyles'
import { cn } from '@/lib/utils'

export function ErrorFallback() {
  const now = useCurrentTime()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-[var(--surface-bg)] px-4 text-center">
      <div
        aria-hidden="true"
        className="font-display text-7xl font-bold tracking-[-0.05em] text-white/[0.07]"
      >
        Oops
      </div>
      <h1 className="font-display text-2xl font-bold text-[var(--text-strong)]">
        Something went wrong
      </h1>
      <p className="max-w-[400px] text-[var(--surface-muted)]">
        An unexpected error occurred. Please try refreshing the page, or message Skillo on WhatsApp.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <a href="/" className={cn(buttonClassName({ variant: 'accent' }), 'rounded-full px-6')}>
          Go to Homepage
        </a>
        <a
          href={buildCounsellingWhatsAppUrl(now)}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(buttonClassName({ variant: 'secondary' }), 'rounded-full px-6')}
        >
          WhatsApp counselling
        </a>
      </div>
    </div>
  )
}
